/* ============================================================================
   Tabulator cell tinting.

   The model formatters paint cells by assigning `element.style.backgroundColor`
   directly. An inline style beats any stylesheet rule that isn't `!important`,
   and the palette is a set of pale pastels (#FFFFC2, #CFD0CF, #B4D3B2 …) that
   turn into unreadable glare on a charcoal table.

   So each call also stamps `data-cell-tint` on the element, naming the *role*
   of the colour rather than the colour itself. The dark layer in
   src/plugins/theme-dark.css keys off that attribute with `!important` and
   substitutes a dark-appropriate pair. Light mode is untouched: the inline
   colour still wins there, so nothing about the existing look changes.
   ============================================================================ */

// Keyed by the lowercased literal the formatters already use.
const TINT_BY_COLOR = {
  "#ffffc2": "amber", // new sale
  "#fff9c4": "amber", // resent email
  "#f5deb3": "wheat", // renewal
  "#cfd0cf": "slate", // pay & refund
  "#ececec": "slate", // claim basis
  "#c3c4c3": "muted", // disabled / not applicable
  "#b4d3b2": "green", // on track
  "#fa8072": "red", // needs attention
  "#ffc4cc": "red", // overdue
  lightblue: "blue", // summary row
};

/**
 * Paint a cell (or row) background and tag it so the dark theme can override.
 * @param {HTMLElement} el   cell.getElement() / row.getElement()
 * @param {string} color     the light-mode colour literal
 */
export default function tintCell(el, color) {
  if (!el) return;
  el.style.backgroundColor = color;
  const tint = TINT_BY_COLOR[String(color).trim().toLowerCase()];
  if (tint) el.setAttribute("data-cell-tint", tint);
  else el.removeAttribute("data-cell-tint");
}

export { TINT_BY_COLOR };
